import {Component, ReactNode} from 'react';
import ErrorBoundaryPage from 'modules/errors/pages/ErrorBoundaryPage';

interface IProps {
    children?: ReactNode;
}

interface IState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {hasError: false};
    }

    static getDerivedStateFromError(_: Error) {
        return {hasError: true};
    }

    componentDidMount(): void {
        window.addEventListener('unhandledrejection', this.promiseRejectionHandler);
    }

    componentWillUnmount(): void {
        window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
    }

    // TODO: разобраться почему скрипты flocktory падают с ошибкой в fierfox
    promiseRejectionHandler = (e: {reason: {fileName: string}}) => {
        if (e?.reason?.fileName?.includes('flocktory') || e?.reason?.fileName === undefined) {
            console.error(e.reason);
            return;
        }

        this.setState({hasError: true});
    };

    render() {
        if (this.state.hasError) {
            return <ErrorBoundaryPage />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
